const steps = [
  {
    number: '01',
    title: 'Customer Sends Enquiry',
    description: 'A potential customer messages via website chat, WhatsApp, or email. Trewaz captures it instantly.',
    icon: 'ri-message-3-line',
  },
  {
    number: '02',
    title: 'AI Responds Instantly',
    description: 'The AI assistant replies within seconds — answers questions, collects details, and qualifies the lead.',
    icon: 'ri-robot-line',
  },
  {
    number: '03',
    title: 'Lead Captured in CRM',
    description: 'All contact details and enquiry data are automatically saved to your CRM pipeline — zero manual entry.',
    icon: 'ri-user-add-line',
  },
  {
    number: '04',
    title: 'Automated Follow-ups',
    description: 'Trewaz sends personalised follow-ups on WhatsApp and email until the lead responds or books.',
    icon: 'ri-notification-3-line',
  },
  {
    number: '05',
    title: 'Booking Confirmed',
    description: 'The customer confirms, a booking is created, invoice sent — all managed inside one platform.',
    icon: 'ri-checkbox-circle-line',
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 md:py-32 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="max-w-xl mb-16">
          <p className="text-sm font-medium uppercase tracking-wider mb-3 bg-gradient-to-r from-teal-500 to-indigo-500 bg-clip-text text-transparent">How It Works</p>
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 leading-tight tracking-tight">
            From Enquiry to Booking —<br />
            <span className="bg-gradient-to-r from-teal-400 to-indigo-400 bg-clip-text text-transparent">to conversion with AI assistance</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-8 left-[60px] right-[60px] h-px bg-gradient-to-r from-teal-200 via-indigo-200 to-teal-200" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={step.number} className="relative flex flex-col gap-4">
                {/* Number + Icon */}
                <div className="flex lg:flex-col items-center lg:items-start gap-4 lg:gap-3">
                  <div className={`relative z-10 w-16 h-16 bg-white border rounded-xl flex items-center justify-center shrink-0 ${
                    index % 2 === 0 ? 'border-teal-200' : 'border-indigo-200'
                  }`}>
                    <i className={`${step.icon} text-xl ${
                      index % 2 === 0 ? 'text-teal-500' : 'text-indigo-500'
                    }`} />
                  </div>
                  <span className={`text-xs font-mono font-semibold hidden lg:block ${
                    index % 2 === 0 ? 'text-teal-400' : 'text-indigo-400'
                  }`}>{step.number}</span>
                </div>

                {/* Content */}
                <div className="flex flex-col gap-1.5">
                  <div className="flex items-center gap-2 lg:hidden">
                    <span className="text-xs font-mono text-gray-300 font-semibold">{step.number}</span>
                    {index < steps.length - 1 && (
                      <div className="flex-1 h-px bg-gray-200" />
                    )}
                  </div>
                  <h3 className="text-sm font-semibold text-gray-900">{step.title}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
